module.exports = __webpack_public_path__ + "img/rightarrow@2x.fddc36d6.png";